import React, { useState, useEffect } from "react";
import PolyProps from "./PolyPropss"; // Matches existing file name
import pp from "../../assets/pp.png";
import pc1 from "../../assets/pc1.png";
import pc2 from "../../assets/pc2.png";
import flagPakistan from "../../assets/pakistan.png";
import flagJapan from "../../assets/japan.png";
import flagSaudiArabia from "../../assets/saudi_arabia.png";
import flagNorway from "../../assets/norway.png";
import flagUAE from "../../assets/united_arab_emirates.png";
import flagUSA from "../../assets/united_states_of_america.png";
// import s1age4 from "../../assets/s1age4.png";
// import s1age7 from "../../assets/s1age7.png";
// import s1age11 from "../../assets/s1age11.png";
// import s2age4 from "../../assets/s2age4.png";
// import s2age7 from "../../assets/s2age7.png";
// import s2age11 from "../../assets/s2age11.png";
// import s3age4 from "../../assets/s3age4.png";
// import s3age7 from "../../assets/s3age7.png";
// import s3age11 from "../../assets/s3age11.png";
import axios from 'axios';

const Science = () => {
  const [competitionData, setCompetitionData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch competition data from database
  useEffect(() => {
    const fetchCompetitionData = async () => {
      try {
        const response = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/allpolymatchcompetition`);
        if (response.data && response.data.length > 0) {
          // Filter competitions that contain "science" in the name (case insensitive)
          const scienceCompetitions = response.data.filter(comp => 
            comp.Competition_Name && comp.Competition_Name.toLowerCase().includes('science')
          );
          setCompetitionData(scienceCompetitions);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching competition data:', error);
        setLoading(false);
      }
    };

    fetchCompetitionData();
  }, []);

  const headerSection = {
    mainHeading: "Science Competition",
    // subHeading: "2025",
    mainImage: pp,
    leftImage: pc1,
    rightImage: pc2,
  };

  const upcomingCompetitionSection = {
    mainHeading: "For Our Upcoming Competition",
    subHeading: "Stay Tuned",
    competitionName: "Science Exploration Competition",
    description:
      "The PolyMatch Science Competition ignites curiosity and celebrates the wonders of science from around the world. This exciting event brings together brilliant minds to explore concepts in physics, chemistry, biology, and beyond. Encouraging innovation, critical thinking, and scientific discovery, participants enhance their knowledge while building meaningful global connections in a dynamic and inspiring atmosphere",
    registerLink: "/PolymatchReg?",
    flags: [
      { src: flagPakistan, alt: "Pakistan Flag" },
      { src: flagJapan, alt: "Japan Flag" },
      { src: flagSaudiArabia, alt: "Saudi Arabia Flag" },
      { src: flagNorway, alt: "Norway Flag" },
      { src: flagUAE, alt: "United Arab Emirates Flag" },
      { src: flagUSA, alt: "United States of America Flag" },
    ],
  };

  // Dynamic competition years section based on database data
  const competitionYearsSection = {
    mainHeading: "Science Competition",
    defaultYear: 2025,
    years: competitionData.map(comp => ({
      year: new Date(comp.Competition_date).getFullYear(),
      title: comp.Competition_Name,
      dates: new Date(comp.Competition_date).toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }),
      description: comp.Competition_Description || "The PolyMatch Science Competition is coming soon! Stay tuned for more details about this exciting event where participants will showcase their amazing scientific knowledge and passion for learning.",
      competitionId: comp.Competition_Id,
    })),
    flags: [
      { src: flagPakistan, alt: "Pakistan Flag" },
      { src: flagJapan, alt: "Japan Flag" },
      { src: flagSaudiArabia, alt: "Saudi Arabia Flag" },
      { src: flagNorway, alt: "Norway Flag" },
      { src: flagUAE, alt: "United Arab Emirates Flag" },
      { src: flagUSA, alt: "United States of America Flag" },
    ],
  };

  const winnersSection = {
    mainHeading: "Congratulations to All Winners!",
    description:
      "We're proud of every participant, and we applaud the outstanding winners who showcased exceptional skills, creativity, and determination. Your hard work truly shines—well done!",
    winners: [
      {
        year: 2025,
        image: "Polymath-images/Winners Pics/2025/science & knowledge/4 to 6/1stPosition-AdeemMizan.png",
        alt: "Age 4-5 Winner",
        ageCategory: "Ages 4-5",
        studentsData: [
          {
            name: "Adeem Mizan",
            rank: "1st Winner",
            country: "Chennai, India",
            age: "6 Years",
            image: 'Polymath-images/Winners Pics/2025/science & knowledge/4 to 6/1stPosition-AdeemMizan.png',
          },
          {
            name: "Noorya Zahra",
            rank: "2nd Winner",
            country: "Lahore, Pakistan",
            age: "6 Years",
            image: 'Polymath-images/Winners Pics/2025/science & knowledge/4 to 6/2ndPosition-NooryaZahra.png',
          },
          {
            name: "Alayna Masood",
            rank: "3rd Winner",
            country: "Islamabad, Pakistan",
            age: "6 Years",
            image: 'Polymath-images/Winners Pics/2025/science & knowledge/4 to 6/3rdPosition-AlaynaMasood.png',
          },
        ],
      },
      {
        year: 2025,
        image: "Polymath-images/Winners Pics/2025/science & knowledge/4 to 6/1stPosition-AdeemMizan.png",
        alt: "Age 6-8 Winner",
        ageCategory: "Ages 6-8",
        studentsData: [
          {
            name: "Priyal Kumari",
            rank: "1st Winner",
            country: "Jeddah, Saudi Arabia",
            age: "8 Years",
            image: "Polymath-images/Winners Pics/2025/science & knowledge/7 to 9/1stPosition-PriyalKumari.png",
          },
          {
            name: "Mutiba Ali Khan",
            rank: "2nd Winner",
            country: "Karachi, Pakistan",
            age: "9 Years",
            image: "Polymath-images/Winners Pics/2025/science & knowledge/7 to 9/2ndPosition-MutibaAliKhan.png",
          },
          {
            name: "Omar Khan",
            rank: "3rd Winner",
            country: "Riyadh, Saudia",
            age: "9 Years",
            image: "Polymath-images/Winners Pics/2025/science & knowledge/7 to 9/3rdPosition-UmarKhan.png",
          },
        ],
      },
      {
        year: 2025,
        image: "Polymath-images/Winners Pics/2025/science & knowledge/4 to 6/1stPosition-AdeemMizan.png",
        alt: "Age 9-11 Winner",
        ageCategory: "Ages 9-11",
        studentsData: [
          {
            name: "Abdullah Ali",
            rank: "1st Winner",
            country: "Lahore, Pakistan",
            age: "10 Years",
            image: "Polymath-images/Winners Pics/2025/science & knowledge/10 to 12/1stPosition-AbdullahAli.png",
          },
          {
            name: "Emaan Ali Khan",
            rank: "2nd Winner",
            country: "Rawalpindi, Pakistan",
            age: "12 Years",
            image: "Polymath-images/Winners Pics/2025/science & knowledge/10 to 12/2ndPosition-EmaanAliKhan.png",
          },
          {
            name: "Leen Mubarak",
            rank: "3rd Winner",
            country: "Tabuk, Saudi Arabia",
            age: "10 Years",
            image: "Polymath-images/Winners Pics/2025/science & knowledge/10 to 12/3rdPosition-LeenMubarak.png",
          },
        ],
      },
      {
        year: 2025,
        image: "Polymath-images/Winners Pics/2025/science & knowledge/4 to 6/1stPosition-AdeemMizan.png",
        alt: "Age 12-15 Winner",
        ageCategory: "Ages 12-15",
        studentsData: [
          {
            name: "Rahaf Mubarak",
            rank: "1st Winner",
            country: "Tabuk, Saudi Arabia",
            age: "13 Years",
            image: "Polymath-images/Winners Pics/2025/science & knowledge/13 to 18/1stPosition-RahafMubarak.png",
          },
          {
            name: "Rhian Margharet",
            rank: "2nd Winner",
            country: "Lipa City Batangas, Philippines",
            age: "14 Years",
            image: "Polymath-images/Winners Pics/2025/science & knowledge/13 to 18/2ndPosition-RhianMargharet.png",
          },
          {
            name: "Khadija",
            rank: "3rd Winner",
            country: "Quetta, Pakistan",
            age: "15 Years",
            image: "Polymath-images/Winners Pics/2025/science & knowledge/13 to 18/3rdPosition-Khadija.png",
          },
        ],
      },
    ],
    resultsLink: "/PolymatchResults_Linguistic",
  };

  const spotlightSection = {
    mainHeading: "Participant Spotlight",
    subHeading: " – Watch Them in Action",
    description:
      "Get inspired by the creativity, confidence, and talent of our young competitors. These videos showcase real moments from PolyMatch participants sharing their experiences, conducting scientific experiments, and celebrating success.",
    participants: [
      {
        name: "Mutiba Ali khan",
        compName: "Science Competition 2024",
        rank: "2nd Winner – Age Category 7 - 9",
        country: "From Pakistan",
        video: "https://youtube.com/shorts/gkk_svxBVFM?si=BSTK-5q2cyXERDej",
      },
      {
        name: "Rhian Margharet Lingao ",
        compName: "Science Competition 2024",
        rank: "2nd Winner – Age Category 13 - 18",
        country: "From Pakistan",
        video: "https://youtube.com/shorts/sY79kFl0p3g?si=f0ZZ5vMx9kXLQOaJ",
      },
      {
        name: "Khadija Zahra ",
        compName: "Science Competition 2024",
        rank: "3rd Winner – Age Category 13 - 18",
        country: "From Pakistan",
        video: "https://youtube.com/shorts/hjCYCLyuBPo?si=ZTslbX65gT1hNeRJ",
      },
      {
        name: "Alayna Masood",
        compName: "Science Competition 2024",
        rank: "3rd Winner – Age Category 4 - 6",
        country: "From Pakistan",
        video: "https://youtube.com/shorts/9o1ghDYxNRw?si=wD3obw570aY_Q77e",
      },
      {
        name: "Emaan Ali Khan",
        compName: "Science Competition 2024",
        rank: "2nd Winner – Age Category 10 - 12",
        country: "From Pakistan",
        video: "https://youtube.com/shorts/dtolwIzKcAg?si=1sAZvHRgbLNt6XNY",
      },
      {
        name: "Priyal Kumari",
        compName: "Science Competition 2024",
        rank: "1st Winner – Age Category 7 - 9",
        country: "From Saudia Arabia",
        video: "https://youtube.com/shorts/Ob-StbA4PXA?si=QGTM827jTy8n2sHm",
      },
    ],
  };

  // Show loading state while fetching data
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading competition data...
      </div>
    );
  }

  // Show message if no science competitions found
  if (!competitionData || competitionData.length === 0) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '18px',
        color: '#666',
        textAlign: 'center',
        padding: '20px'
      }}>
        <div>
          <h3>No science competitions found</h3>
          <p>Please check back later for upcoming science competitions.</p>
        </div>
      </div>
    );
  }

  return (
    <PolyProps
      headerSection={headerSection}
      upcomingCompetitionSection={upcomingCompetitionSection}
      competitionYearsSection={competitionYearsSection}
      winnersSection={winnersSection}
      spotlightSection={spotlightSection}
      text={"Upcoming Event: June 2026"}
    />
  );
};

export default Science;
